/* eslint-disable prefer-rest-params */ import { useMemo } from "react";
import { computed } from "../core";
/** @public */ export function useComputed() {
    const name = arguments[0];
    const compute = arguments[1];
    const opts = arguments.length === 3 ? undefined : arguments[2];
    const deps = arguments.length === 3 ? arguments[2] : arguments[3];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useMemo(()=>computed(`useComputed(${name})`, compute, opts), deps);
}
